module.exports = __webpack_public_path__ + "img/3-5-2.7aacc2bd.png";